export interface ViewerFallbackState {
  unavailable: true
  message: string
}

/**
 * Keep the homepage useful when its optional CDN-backed demonstration cannot
 * start. The source error remains reported to Bugsnag, but it is never copied
 * into the page because an image URL can contain customer-specific data.
 */
export const getViewerFallbackState = (_error: unknown): ViewerFallbackState => ({
  unavailable: true,
  message: 'The interactive preview is temporarily unavailable. You can continue browsing the site.',
})
